import { Injectable } from "@angular/core";
import { HashMap, TranslocoService, type TranslocoEvents } from "@ngneat/transloco";
import { BehaviorSubject, Observable } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import type { Language } from "src/app/transloco.config";

@Injectable({ providedIn: "root" })
export class TranslateService {
  private _enabled$ = new BehaviorSubject<boolean>(true);
  public readonly enabled$ = this._enabled$.asObservable();

  public setEnabled(enabled: boolean): void {
    this._enabled$.next(enabled);
  }

  constructor(
    private _translocoService: TranslocoService,
    private _localStorageService: LocalStorageService,
  ) {}

  public setLanguage(lang: Language): void {
    this._translocoService.setActiveLang(lang);
    this._localStorageService.set("language", lang);
  }

  public getTranslationObject(key: string, params?: HashMap, lang?: Language) {
    return this._translocoService.translateObject(key, params, lang);
  }

  public selectTranslationObject(
    key: string,
    params?: HashMap,
    lang?: Language,
  ): Observable<HashMap> {
    return this._translocoService.selectTranslateObject(key, params, lang);
  }

  public getTranslation(key: string, params?: HashMap, lang?: string): string {
    return this._translocoService.translate(key, params, lang);
  }

  public getSelectedLanguage(): Language {
    return (this._localStorageService.get("language") as Language) ?? "en";
  }

  public events$(): Observable<TranslocoEvents> {
    return this._translocoService.events$;
  }
}
